import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const testimonials = [
  {
    name: '林女士',
    age: '38岁',
    role: '企业高管',
    content: '关注永葆青春已经一年多了，按照上面的护肤和饮食建议调整后，皮肤状态明显改善，同事都以为我做了什么医美项目。其实只是用对了方法，坚持了下来。',
  },
  {
    name: '张先生',
    age: '45岁',
    role: '创业者',
    content: '以前觉得抗衰老是女人的事，直到体检发现各种指标偏高才开始重视。这个平台的运动指导和饮食方案非常实用，三个月下来体重减了8公斤，整个人年轻了不止五岁。',
  },
  {
    name: '陈女士',
    age: '52岁',
    role: '教师',
    content: '特别是关于睡眠和心理健康的文章对我帮助最大。按照网站的睡眠指南调整作息后，失眠问题大为改善，气色好了很多。真心推荐给每一位想要保持年轻态的朋友。',
  },
  {
    name: '王女士',
    age: '30岁',
    role: '设计师',
    content: '从25岁就开始关注抗衰，但之前走了很多弯路。永葆青春的内容科学、系统，不贩卖焦虑，是我找到的最靠谱的抗衰知识平台。已经推荐给身边所有姐妹了！',
  },
  {
    name: '刘先生',
    age: '56岁',
    role: '退休医生',
    content: '作为一名退休医生，我很认可这个平台的专业性。所有建议都有科学依据，不是凭空捏造。强烈建议中老年朋友多看看这里的文章，科学养生比乱吃保健品强太多了。',
  },
  {
    name: '赵女士',
    age: '35岁',
    role: '全职妈妈',
    content: '生完二胎后感觉自己老了很多，朋友推荐了这个网站。跟着做了三个月，皮肤紧致了，精力也好了，带娃都能感受到变化。感谢这么好的平台！',
  },
];

export default function AboutPage() {
  const [formSuccess, setFormSuccess] = useState(false);
  const [formError, setFormError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormError('');

    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('phone_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormSuccess(true);
      form.reset();
      return;
    }

    setSubmitting(true);
    try {
      const formData = new FormData(form);
      const res = await fetch('https://readdy.ai/api/form/d9u19153pcjqs2fcskeg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (res.ok && parsed?.code === 'OK') {
        setFormSuccess(true);
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后重试';
        if (msg.toLowerCase().includes('spam') || msg.includes('spam')) {
          setFormSuccess(true);
          form.reset();
        } else {
          setFormError(msg);
        }
      }
    } catch {
      setFormError('网络错误，请稍后重试');
    } finally {
      setSubmitting(false);
    }
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '永葆青春',
    url: 'https://lztprh.cn/',
    description: '科学抗衰知识平台，汇集护肤养生、饮食运动、心理健康全方位抗衰老方案。',
    address: {
      '@type': 'PostalAddress',
      addressLocality: '上海',
      addressRegion: '上海',
      addressCountry: 'CN',
      streetAddress: '静安区南京西路1688号',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-6688',
      contactType: 'customer service',
    },
  };

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
        />

        <section className="py-14 md:py-20 bg-background-100">
          <div className="w-full px-6 md:px-10 max-w-7xl mx-auto">
            <nav className="flex items-center gap-2 text-sm text-foreground-400 mb-6" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-700">关于我们</span>
            </nav>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
              <div>
                <span className="inline-block text-xs font-label font-semibold tracking-widest uppercase text-accent-600 bg-accent-100 px-4 py-1.5 rounded-full">
                  关于我们
                </span>
                <h1 className="mt-4 text-2xl md:text-4xl font-heading font-semibold text-foreground-950 leading-tight">
                  以科学之力，<br />守护你的年轻状态
                </h1>
                <div className="mt-6 space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                  <p>
                    <strong className="text-foreground-900">永葆青春</strong> 成立于2020年，是一个专注于科学抗衰的中文知识平台。我们坚信，衰老不是不可逆的宿命——通过科学的护肤方法、合理的饮食搭配、适度的运动计划和健康的生活习惯，每个人都可以延缓衰老的步伐，绽放属于自己的年轻光彩。
                  </p>
                  <p>
                    我们的内容团队由皮肤科医生、营养师、健身教练、心理咨询师等专业人士组成，确保每篇文章都有扎实的科学研究支撑。我们不贩卖焦虑，不推销产品，只提供经得起推敲的抗衰知识。
                  </p>
                  <p>
                    截至目前，永葆青春已累计发布超过<strong className="text-primary-600">500篇</strong>专业抗衰文章，服务超过<strong className="text-primary-600">100万</strong>读者，成为华语世界最具影响力的科学抗衰平台之一。
                  </p>
                </div>
              </div>
              <div className="w-full h-72 md:h-96 rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20wellness%20brand%20office%20interior%20with%20warm%20cream%20walls%2C%20natural%20wood%20furniture%2C%20indoor%20plants%2C%20soft%20morning%20light%20through%20large%20windows%2C%20serene%20professional%20atmosphere%2C%20lifestyle%20photography%20with%20gentle%20shadows&width=1200&height=900&seq=about-brand&orientation=landscape"
                  alt="永葆青春品牌形象"
                  className="w-full h-full object-cover"
                  title="永葆青春 - 科学抗衰知识平台"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="w-full px-6 md:px-10 max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <span className="inline-block text-xs font-label font-semibold tracking-widest uppercase text-primary-600 bg-primary-100 px-4 py-1.5 rounded-full">
                用户口碑
              </span>
              <h2 className="mt-4 text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
                听听他们怎么说
              </h2>
              <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
                真实用户的抗衰故事，每一个改变都值得被看见
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {testimonials.map((t, idx) => (
                <div key={idx} className="bg-background-100 rounded-xl p-5 md:p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                      <span className="text-sm font-semibold text-accent-700">{t.name[0]}</span>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-800">{t.name}</p>
                      <p className="text-xs text-foreground-400">{t.role} · {t.age}</p>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{t.content}</p>
                  <div className="flex items-center gap-1 mt-3 text-accent-500">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="w-full px-6 md:px-10 max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14">
              <div>
                <span className="inline-block text-xs font-label font-semibold tracking-widest uppercase text-accent-600 bg-accent-100 px-4 py-1.5 rounded-full">
                  联系我们
                </span>
                <h2 className="mt-4 text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
                  期待你的声音
                </h2>
                <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
                  有任何关于抗衰老的问题、建议或合作意向，欢迎通过下方表单与我们联系。我们会尽快回复。
                </p>

                <div className="mt-8 space-y-5">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                      <i className="ri-mail-line text-accent-600 text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">邮箱</p>
                      <p className="text-sm text-foreground-500">contact@lztprh.cn</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                      <i className="ri-phone-line text-accent-600 text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">电话</p>
                      <p className="text-sm text-foreground-500">400-888-6688</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                      <i className="ri-map-pin-line text-accent-600 text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">地址</p>
                      <p className="text-sm text-foreground-500">上海市静安区南京西路1688号恒隆广场18层</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-background-50 rounded-xl p-6 md:p-8">
                <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-6">发送消息</h3>
                <form
                  onSubmit={handleSubmit}
                  data-readdy-form
                  className="space-y-4"
                >
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        required
                        className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-800 focus:outline-none focus:border-accent-400 transition-colors"
                      />
                    </div>
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-800 focus:outline-none focus:border-accent-400 transition-colors"
                      />
                    </div>
                  </div>
                  <div>
                    <label htmlFor="subject" className="block text-sm font-medium text-foreground-700 mb-1.5">主题</label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      required
                      className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-800 focus:outline-none focus:border-accent-400 transition-colors"
                    />
                  </div>
                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-foreground-700 mb-1.5">消息内容</label>
                    <textarea
                      id="message"
                      name="message"
                      rows={5}
                      maxLength={500}
                      required
                      className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-800 focus:outline-none focus:border-accent-400 transition-colors resize-none"
                    ></textarea>
                    <p className="mt-1 text-xs text-foreground-400">最多500个字符</p>
                  </div>
                  <div className="spam-guard">
                    <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden={true} readOnly />
                  </div>
                  <button
                    type="submit"
                    disabled={submitting}
                    className="w-full py-3 bg-accent-600 hover:bg-accent-700 text-white font-medium text-sm rounded-lg transition-colors duration-200 cursor-pointer disabled:opacity-50 whitespace-nowrap"
                  >
                    {submitting ? '发送中...' : '发送消息'}
                  </button>
                  {formSuccess && (
                    <p className="text-sm text-accent-600 text-center">消息发送成功！我们会尽快回复你。</p>
                  )}
                  {formError && (
                    <p className="text-sm text-red-500 text-center">{formError}</p>
                  )}
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}